module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.4674f8de.eot";